import { UNSCHEDULED_BOOKING_STATES } from 'Data/constants.js'

export function isNotUnscheduledAppointment(appointment) {
  return (
    appointment.booking.length > 0 &&
    !UNSCHEDULED_BOOKING_STATES.includes(appointment.booking[0]?.state)
  )
}
